import { render } from "./MainListOfInsuranceAccountsReceivable.vue?vue&type=template&id=159277d7&scoped=true"
import script from "./MainListOfInsuranceAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./MainListOfInsuranceAccountsReceivable.vue?vue&type=script&lang=js"

import "./MainListOfInsuranceAccountsReceivable.vue?vue&type=style&index=0&id=159277d7&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159277d7"]])

export default __exports__